window.semester = () => {
    return {
        open: false,
    };
};
